import React, { ButtonHTMLAttributes } from 'react';
import ButtonWrapper, { RoundedButtonWrapper } from './styles';
import Loading from '../../Loading';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	loading?: boolean;
	rounded?: boolean;
	icon?: string;
	themeType?: 'primary' | 'success' | 'warning' | 'danger';
}

const Button: React.FC<ButtonProps> = ({
	children,
	loading,
	rounded,
	themeType,
	...rest
}) => {
	if (rounded) {
		return (
			<RoundedButtonWrapper
				disabled={loading}
				className={themeType}
				{...rest}
			>
				{loading ? <Loading size={19} /> : children}
			</RoundedButtonWrapper>
		);
	}
	return (
		<ButtonWrapper disabled={loading} className='button' {...rest}>
			{loading ? <Loading size={19} /> : children}
		</ButtonWrapper>
	);
};

Button.defaultProps = {
	themeType: 'primary',
};

export default Button;
